import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import { SelectOption } from '@core/ui';
import { TreeFacet } from '@mp/shared/facets/domain';

@Component({
  selector: 'mp-tree-facet-autocomplete-option',
  templateUrl: './tree-facet-autocomplete-option.component.html',
  styleUrl: './tree-facet-autocomplete-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeFacetAutocompleteOptionComponent<TData extends object | unknown = unknown> {
  readonly bucketOption: InputSignal<SelectOption<TreeFacet.Bucket<TData>>> =
    input.required<SelectOption<TreeFacet.Bucket<TData>>>();
}
